enum GatewayNetworkConstants {
  UNDEFINED = 'UNDEFINED',
  WIFI = 'WIFI',
  CELLULAR = 'CELLULAR',
}

export default GatewayNetworkConstants;
